import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Plane, Building2, Headphones, BadgeCheck, Car, Gem } from "lucide-react";

const AdvantagesSection = () => {
  const { t } = useTranslation();

  const advantages = [
    { icon: BadgeCheck, title: t("advantages.visa"), desc: t("advantages.visaDesc") },
    { icon: Building2, title: t("advantages.banking"), desc: t("advantages.bankingDesc") },
    { icon: Headphones, title: t("advantages.concierge"), desc: t("advantages.conciergeDesc") },
    { icon: Plane, title: t("advantages.airport"), desc: t("advantages.airportDesc") },
    { icon: Car, title: t("advantages.limousine"), desc: t("advantages.limousineDesc") },
    { icon: Gem, title: t("advantages.lifestyle"), desc: t("advantages.lifestyleDesc") },
  ];

  return (
    <section id="advantages" className="py-20 lg:py-28 bg-background">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-xs font-body font-semibold tracking-[0.2em] uppercase text-accent mb-3 block">
            {t("advantages.badge")}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-display font-bold text-foreground mb-6">
            {t("advantages.title")}
          </h2>
          <p className="text-base text-muted-foreground font-body max-w-2xl mx-auto">
            {t("advantages.description")}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {advantages.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="flex gap-4 p-6 rounded-lg border border-border hover:border-accent/30 hover:shadow-card transition-all"
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-md bg-gradient-gold flex items-center justify-center">
                <item.icon className="h-5 w-5 text-accent-foreground" />
              </div>
              <div>
                <h3 className="text-base font-display font-semibold text-foreground mb-1">
                  {item.title}
                </h3>
                <p className="text-sm text-muted-foreground font-body leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
